import * as React from "react"

const Alert = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.9 42.56" {...props}>
    <title>{"parcel-journey-10-alert-icon-2"}</title>
    <path
      d="M18.45 42.56a6.49 6.49 0 0 0 6.46-6.07H12a6.48 6.48 0 0 0 6.45 6.07ZM30.93 15.18a12.46 12.46 0 0 0-8.86-11.92 3.64 3.64 0 0 0-7.24 0A12.46 12.46 0 0 0 6 15.18c0 21.47-6 12.81-6 19.2h36.9v-.3c0-5.52-5.97 2.02-5.97-18.9Z"
      fill="#4ead90"
    />
  </svg>
)

export default Alert
